import template from './radio-field.html';

const RadioFieldComponent = {
    bindings: {
        hideLabel: '<',
        inputClass: '<',
        label: '<',
        labelClass: '<',
        onSelect: '&',
        options: '<'
    },
    template
};

export default RadioFieldComponent;



// WEBPACK FOOTER //
// ./app/common/form-fields/radio-field/radio-field-component.js